import React from 'react'
import i18n from 'i18next'

import Button from '../../UniformComponents/Button'

import './distribute.scss'

const LandingScreenOption = ({
    onClick, icon, title, color,
}) => (
    <a className={`panel-container ${color}`} onClick={onClick}>
        <div className={`panel-icon-wrapper ${color}`}>
            <i className={icon} />
        </div>

        <h4>{title}</h4>

        <Button
            cssClass={`panel-button ${color}`}
            onClick={onClick}
            label={i18n.t('distributionLandingScreen.getStarted')}
        />
    </a>
)

export default LandingScreenOption
